var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            "no-close-on-backdrop": true,
            id: "create-new-band",
            size: "lg",
            "no-enforce-focus": "",
            title: _vm.formTitle
          },
          on: {
            shown: _vm.focusMyElement,
            show: function($event) {
              return _vm.onShow()
            }
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-name",
                label: "Name",
                "label-for": "name"
              }
            },
            [
              _c("b-form-input", {
                ref: "name",
                attrs: {
                  id: "name",
                  name: "name",
                  state: _vm.$v.data.name.$dirty
                    ? !_vm.$v.data.name.$error
                    : null,
                  "aria-describedby": "name-live-feedback"
                },
                model: {
                  value: _vm.$v.data.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.data.name, "$model", $$v)
                  },
                  expression: "$v.data.name.$model"
                }
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { id: "name-live-feedback" } },
                [_vm._v("The name field is required.")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.sharedModalOptions.hideContactForm == false
            ? _c(
                "b-form-row",
                [
                  _c(
                    "b-form-group",
                    { staticClass: "col-sm-12", attrs: { label: "" } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n          Primary Contact\n          "),
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            attrs: { href: "#" },
                            on: { click: _vm.createNewPrimaryContact }
                          },
                          [_c("i", { staticClass: "ion ion-md-add-circle" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            id: "primary_contact_ajax",
                            label: "full_name",
                            "track-by": "id",
                            placeholder: "Type to search",
                            "open-direction": "bottom",
                            options: _vm.primary_contact_options,
                            multiple: false,
                            searchable: true,
                            loading: _vm.isPrimaryContactLoading,
                            "internal-search": false,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "max-height": 600,
                            "show-no-results": false,
                            "hide-selected": true
                          },
                          on: { "search-change": _vm.asyncContactFind },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "clear",
                                fn: function(props) {
                                  return undefined
                                }
                              }
                            ],
                            null,
                            false,
                            1632182706
                          ),
                          model: {
                            value: _vm.data.primary_contact,
                            callback: function($$v) {
                              _vm.$set(_vm.data, "primary_contact", $$v)
                            },
                            expression: "data.primary_contact"
                          }
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("Contact not found.")]
                          )
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sharedModalOptions.hideContactForm == false
            ? _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "col-lg-6",
                      attrs: {
                        label: "Total Members",
                        "invalid-feedback": _vm.getErrorLabel(
                          _vm.$v.data.total_members
                        )
                      }
                    },
                    [
                      _c("b-input", {
                        attrs: {
                          state: _vm.$v.data.total_members.$error
                            ? "invalid"
                            : null
                        },
                        model: {
                          value: _vm.data.total_members,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "total_members", $$v)
                          },
                          expression: "data.total_members"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sharedModalOptions.hideContactForm == false
            ? _c(
                "b-form-row",
                [
                  _c(
                    "b-form-group",
                    { staticClass: "col-sm-12", attrs: { label: "" } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v("\n          List of Members\n          "),
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.createNewMemberContact }
                          },
                          [_c("i", { staticClass: "ion ion-md-add-circle" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            id: "ajax",
                            label: "full_name",
                            "track-by": "id",
                            placeholder: "Type to search",
                            "open-direction": "bottom",
                            options: _vm.primary_contact_options,
                            multiple: true,
                            searchable: true,
                            loading: _vm.isPrimaryContactLoading,
                            "internal-search": false,
                            "clear-on-select": false,
                            "close-on-select": false,
                            "max-height": 600,
                            "show-no-results": false,
                            "hide-selected": true
                          },
                          on: { "search-change": _vm.asyncContactFind },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "tag",
                                fn: function(ref) {
                                  var option = ref.option
                                  var remove = ref.remove
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "badge badge-primary mr-2"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(option.full_name))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: { color: "white" },
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return remove(option)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-times ml-2"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "clear",
                                fn: function(props) {
                                  return [
                                    _vm.data.members.length
                                      ? _c("div", {
                                          staticClass: "multiselect__clear",
                                          on: {
                                            mousedown: function($event) {
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.clearAll(props.search)
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3094712933
                          ),
                          model: {
                            value: _vm.data.members,
                            callback: function($$v) {
                              _vm.$set(_vm.data, "members", $$v)
                            },
                            expression: "data.members"
                          }
                        },
                        [
                          _vm._v(" "),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("Contact not found.")]
                          )
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr", { staticClass: "border-light mt-3" }),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                { staticClass: "col-sm-12", attrs: { label: "Genre" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.genre_options },
                    model: {
                      value: _vm.data.genre_id,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "genre_id", $$v)
                      },
                      expression: "data.genre_id"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-sm-12",
                  attrs: { label: "Musical Influences" }
                },
                [
                  _c("b-input", {
                    ref: "music_influences",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.music_influences,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "music_influences", $$v)
                      },
                      expression: "data.music_influences"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-sm-12",
                  attrs: { label: "Music Sounds Like" }
                },
                [
                  _c("b-input", {
                    ref: "music_sounds_like",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.music_sounds_like,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "music_sounds_like", $$v)
                      },
                      expression: "data.music_sounds_like"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-lg-12",
                  attrs: { label: "Studio Experience" }
                },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.studio_experience_options },
                    model: {
                      value: _vm.data.studio_experience,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "studio_experience", $$v)
                      },
                      expression: "data.studio_experience"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-lg-12",
                  attrs: { label: "Favorite Snacks/Drink" }
                },
                [
                  _c("b-input", {
                    ref: "favorite_foods_and_drinks",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.favorite_foods_and_drinks,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "favorite_foods_and_drinks", $$v)
                      },
                      expression: "data.favorite_foods_and_drinks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-form-group",
                { staticClass: "col-sm-12", attrs: { label: "Website" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.data.website,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "website", $$v)
                      },
                      expression: "data.website"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "Manager" } },
                [
                  _c("b-input", {
                    ref: "manager",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.manager,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "manager", $$v)
                      },
                      expression: "data.manager"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-lg-12",
                  attrs: { label: "Music Publisher" }
                },
                [
                  _c("b-input", {
                    ref: "music_publisher",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.music_publisher,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "music_publisher", $$v)
                      },
                      expression: "data.music_publisher"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "Record Label" } },
                [
                  _c("b-input", {
                    ref: "record_label",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.record_label,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "record_label", $$v)
                      },
                      expression: "data.record_label"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-lg-12",
                  attrs: { label: "Session Collaborators" }
                },
                [
                  _c("b-input", {
                    ref: "collaborators",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.collaborators,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "collaborators", $$v)
                      },
                      expression: "data.collaborators"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "col-lg-12",
                  attrs: { label: "PRO / Collection Society" }
                },
                [
                  _c("b-input", {
                    ref: "pro_collection_society",
                    staticClass: "mb-1",
                    model: {
                      value: _vm.data.pro_collection_society,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "pro_collection_society", $$v)
                      },
                      expression: "data.pro_collection_society"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "Bio" } },
                [
                  _c("b-textarea", {
                    attrs: { rows: "5" },
                    model: {
                      value: _vm.data.bio,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "bio", $$v)
                      },
                      expression: "data.bio"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "Country" } },
                [
                  _c("b-form-select", {
                    attrs: {
                      disabled: _vm.loadingStates,
                      options: _vm.countries_options
                    },
                    model: {
                      value: _vm.data.country,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "country", $$v)
                      },
                      expression: "data.country"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "Address" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.data.street,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "street", $$v)
                      },
                      expression: "data.street"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "City" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.data.city,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "city", $$v)
                      },
                      expression: "data.city"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-form-group",
                { staticClass: "col-lg-12", attrs: { label: "State" } },
                [
                  _vm.loadingStates
                    ? _c("b-spinner", {
                        staticClass: "ml-2 mt-3",
                        attrs: { small: "" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        options: _vm.states_options,
                        disabled: _vm.loadingStates
                      },
                      model: {
                        value: _vm.data.state,
                        callback: function($$v) {
                          _vm.$set(_vm.data, "state", $$v)
                        },
                        expression: "data.state"
                      }
                    },
                    [
                      _c("template", { slot: "first" }, [
                        _c(
                          "option",
                          {
                            attrs: { disabled: "" },
                            domProps: { value: null }
                          },
                          [_vm._v("-- Please select state --")]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "b-form-group",
                { staticClass: "col-6", attrs: { label: "Zip" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.data.zip_code,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "zip_code", $$v)
                      },
                      expression: "data.zip_code"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "border-light mt-3" }),
          _vm._v(" "),
          _c("strong", [_vm._v("Social Media Links")]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "table table-fixed table-borderless" },
            [
              _c("tr", [
                _c("th", { staticStyle: { width: "46%" } }, [
                  _vm._v("Social Media Site")
                ]),
                _vm._v(" "),
                _c("th", { staticStyle: { width: "46%" } }, [
                  _vm._v("Social Media URL")
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "btn-circle btn-primary",
                        on: { click: _vm.addSocialMediaRow }
                      },
                      [_c("i", { staticClass: "fas fa-plus" })]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.$v.data.social_medias.$each.$iter, function(v, index) {
                return _c("tr", { key: index }, [
                  _c(
                    "td",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "",
                            "invalid-feedback": _vm.getErrorLabel(v.site)
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              state: v.site.$error ? "invalid" : null,
                              options: _vm.social_medias_options
                            },
                            model: {
                              value: v.site.$model,
                              callback: function($$v) {
                                _vm.$set(v.site, "$model", $$v)
                              },
                              expression: "v.site.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "",
                            "invalid-feedback": _vm.getErrorLabel(v.url)
                          }
                        },
                        [
                          _c("b-input", {
                            attrs: { state: v.url.$error ? "invalid" : null },
                            model: {
                              value: v.url.$model,
                              callback: function($$v) {
                                _vm.$set(v.url, "$model", $$v)
                              },
                              expression: "v.url.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "btn-circle btn-primary ml-2",
                          on: {
                            click: function($event) {
                              return _vm.deleteSocialMediaRow(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ],
                    1
                  )
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "border-light mt-3" }),
          _vm._v(" "),
          _c("strong", [_vm._v("Music Media Links")]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "table table-fixed table-borderless" },
            [
              _c("tr", [
                _c("th", { staticStyle: { width: "46%" } }, [
                  _vm._v("Music Media Site")
                ]),
                _vm._v(" "),
                _c("th", { staticStyle: { width: "46%" } }, [
                  _vm._v("Music Media URL")
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "btn-circle btn-primary",
                        on: { click: _vm.addMusicMediaRow }
                      },
                      [_c("i", { staticClass: "fas fa-plus" })]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.$v.data.music_medias.$each.$iter, function(v, index) {
                return _c("tr", { key: index }, [
                  _c(
                    "td",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "",
                            "invalid-feedback": _vm.getErrorLabel(v.site)
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              state: v.site.$error ? "invalid" : null,
                              options: _vm.music_medias_options
                            },
                            model: {
                              value: v.site.$model,
                              callback: function($$v) {
                                _vm.$set(v.site, "$model", $$v)
                              },
                              expression: "v.site.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "",
                            "invalid-feedback": _vm.getErrorLabel(v.url)
                          }
                        },
                        [
                          _c("b-input", {
                            attrs: { state: v.url.$error ? "invalid" : null },
                            model: {
                              value: v.url.$model,
                              callback: function($$v) {
                                _vm.$set(v.url, "$model", $$v)
                              },
                              expression: "v.url.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "btn-circle btn-primary ml-2",
                          on: {
                            click: function($event) {
                              return _vm.deleteMusicMediaRow(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ],
                    1
                  )
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "border-light mt-3" }),
          _vm._v(" "),
          _c("custom-field-form-template", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isCustomFieldsAvailable,
                expression: "isCustomFieldsAvailable"
              }
            ],
            attrs: { data: _vm.data, object: "Band" },
            on: {
              "update:data": function($event) {
                _vm.data = $event
              },
              "custom-fields-loaded": _vm.handleCustomFieldsLoaded
            }
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "modal-footer" },
            [
              _c(
                "b-button",
                {
                  attrs: { disabled: _vm.loading, variant: "default" },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { disabled: _vm.loading, variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }